import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageService } from '../storage/storage.service';
import { APP_CONFIG, AppConfig } from '../../../app.config';
import { Login } from '../../models/signin/login';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private config = inject<AppConfig>(APP_CONFIG);
  private httpClient = inject(HttpClient);
  private storageService = inject(StorageService);


  public authenticate(credentials: Login): Observable<any> {
    const payload = {
      username: credentials.username,
      password: btoa(credentials.password)
    };
    return this.httpClient.post(`${this.config.api}/api/authenticate`, payload);
  }

  public logout(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.storageService.clear();
      this.httpClient.post(`${this.config.api}/api/logout`, {})
        .subscribe({
          error: (error: any) => {
            console.error("Error while logging out", error);
            reject(error);
          },
          complete: () => {
            resolve();
          },
        });
    });
  }

  public sendRetrievePasswordEmail(email: string): Observable<any> {
    const frontUrl = this.config.frontendUrl + '/authentication/forgotPassword';
    const encodedUrl = btoa(frontUrl);
    return this.httpClient.get<any>(
      `${this.config.api}/api/resetPassword/request?email=${email}&url=${encodedUrl}`
    );
  }

  performPasswordReset(payload: { login: string, code: string, password: string }) {
    return this.httpClient.post(`${this.config.api}/api/resetPassword/perform`, payload);
  }
  
  public resendActivationLink(username: string): Observable<any> {
    const frontUrl = this.config.frontendUrl + '/authentication/login';
    const encodedUrl = btoa(frontUrl);
    return this.httpClient.get(`${this.config.api}/api/signup/resend?login=${username}&url=${encodedUrl}`);
  }
}
